export default __webpack_public_path__ + "static/media/MainUnit-Yellow-24x24.a1511e19.svg";